import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { submitOffer } from "../../redux/actions/offer";
import { toast } from "react-toastify";
import { HiOutlineChatAlt2 } from "react-icons/hi";

const OfferForm = ({ product, onClose }) => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.user);
  const { isLoading } = useSelector((state) => state.offers);
  const [offerAmount, setOfferAmount] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isAuthenticated) return toast.error("Please log in to submit an offer");
    const amount = Number(offerAmount);
    if (!amount || amount <= 0) return toast.error("Enter a valid amount");

    dispatch(
      submitOffer({
        productId: product._id,
        offerAmount: amount,
        message,
      })
    ).then((result) => {
      if (result?.success) {
        toast.success("Offer submitted! Admin will review it.");
        if (onClose) onClose();
      }
    });
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4">
      <div className="flex items-center gap-2 mb-3">
        <HiOutlineChatAlt2 className="w-5 h-5 text-[#086872]" />
        <h3 className="font-semibold text-gray-900 text-sm">Make an Offer</h3>
      </div>

      <div className="bg-gray-50 rounded-lg p-3 mb-3 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-500">Listed Price:</span>
          <span className="font-medium">₹{product.displayPrice || product.discountPrice || product.originalPrice}</span>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="space-y-3">
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Your Offer (₹)</label>
          <input
            type="number"
            min="1"
            value={offerAmount}
            onChange={(e) => setOfferAmount(e.target.value)}
            className="w-full border border-gray-300 rounded-lg p-2.5 text-sm focus:ring-2 focus:ring-[#086872] focus:border-transparent"
            placeholder="Enter your price"
            required
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Message (optional)</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="w-full border border-gray-300 rounded-lg p-2.5 text-sm focus:ring-2 focus:ring-[#086872] resize-none"
            rows="2"
            placeholder="Why this price?"
          />
        </div>
        <button
          type="submit"
          disabled={isLoading}
          className="w-full px-4 py-2.5 bg-[#086872] text-white rounded-lg text-sm font-medium hover:bg-[#065a63] disabled:opacity-50 transition-colors"
        >
          {isLoading ? "Submitting..." : "Submit Offer"}
        </button>
      </form>
    </div>
  );
};

export default OfferForm;
